import React from 'react';
import { Entity, FiltersGrouped, FiltersValues } from '../types';
import { containers } from '@ecosystem/newron-design-system';
import { FilterGroups } from './filterGroups';
import './filterGroupContainer.css';

interface FilterGroupContainerProps {
  grouped: FiltersGrouped[];
  values: FiltersValues;
  onChange: (name: string, values: Entity[]) => void;
  getIsDisabled: (definitionName: string) => boolean;
}

const { Accordion } = containers;

function FilterGroupContainer({ grouped, values, onChange, getIsDisabled }: FilterGroupContainerProps) {
  return (
    <div className="mb-6">
      <Accordion iconRight={true} flushAlign={true}>
        {grouped.map(group => (
          <Accordion.Item key={group.code} title={group.label}>
            <FilterGroups
              code={group.code}
              label={group.label}
              definitions={group.definitions}
              values={values}
              onChange={onChange}
              getIsDisabled={getIsDisabled}
            />
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
}

export { FilterGroupContainer };
